import { GanttActionButton } from "./GanttControls";

const GanttHeader = ({
  dirty,
  hasItems,
  isFullscreen,
  loading,
  workspaceView,
  onDownloadExcel,
  onGenerate,
  onSave,
  onToggleFullscreen
}) => (
  <header className="gantt-header">
    <div>
      <h1>Gantt Studio</h1>
      <p>{workspaceView ? "Consolidated timeline from every workstream." : "Plan parallel epic delivery from project scope, team capacity, and ticket complexity."}</p>
    </div>
    <div className="gantt-actions">
      <GanttActionButton variant="generate" icon="spark" label={loading ? "Working..." : "Generate from project data"} onClick={onGenerate} disabled={loading} />
      <GanttActionButton icon="excel" label="Export Excel" onClick={onDownloadExcel} disabled={loading || !hasItems || dirty} />
      <GanttActionButton variant="save" icon="save" label="Save latest version" onClick={onSave} disabled={loading || !dirty || !hasItems} />
      <GanttActionButton icon={isFullscreen ? "collapse" : "expand"} label={isFullscreen ? "Exit full screen" : "Full screen"} onClick={onToggleFullscreen} />
    </div>
  </header>
);

export default GanttHeader;
